import { Container } from "./styles";

import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

export const Captcha = React.forwardRef(({ name, onValueChange }, ref) => {
    const handleChange = React.useCallback(
        (token) => {
            if (onValueChange) {
                onValueChange({
                    name,
                    value: token || "",
                });
            }
        },
        [name, onValueChange]
    );

    return (
        <Container>
            <ReCAPTCHA
                ref={ref}
                sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA || ""}
                theme="dark"
                hl="pt-BR"
                onChange={handleChange}
                onErrored={handleChange}
            />
        </Container>
    );
});
